<template>
    <tr>
      <!-- title -->
      <td class="text-left ml-5">
        <router-link class="color-default" :to="'/user-guide/' + userGuide.slug">{{ userGuide.title }}</router-link>
      </td>
      <td v-if="userGuide.published == 1">
        <span class="text-success font-weight-bold">Yes</span>
      </td>
      <td v-else>
        <span class="text-danger font-weight-bold">No</span>
      </td>
      <td v-if="userGuide.featured == 1">
        <span class="text-success font-weight-bold">Yes</span>
      </td>
      <td v-else>
        <span class="text-danger font-weight-bold">No</span>
      </td>
      <!-- controls [Update, Delete] -->
      <td>
        <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
          <span class="fas fa-ellipsis-v"></span>
        </a>
        <ul class="dropdown-menu">
          <router-link class="dropdown-item" :to="'/user-guide/edit/' + userGuide.slug">Update</router-link>
          <template>
            <a class="dropdown-item" v-if="userGuide.published == 0" @click="publishing('publish')">Publish</a>
            <a class="dropdown-item" v-else @click="publishing('unpublish')">Unpublish</a>
          </template>
          <a class="dropdown-item text-danger" @click="deleteuserGuide">Delete</a>
        </ul>
      </td>
    </tr>
  </template>
  
  <script>
    export default {
      name: "FAQRow",
      props: ["userGuide", "pageNumber"],
      computed: {
        author: function () {
          if (typeof this.userGuide.author === "undefined") {
            return "unknown";
          }
          return this.userGuide.author.name;
        },
      },
      methods: {
        publishing(action) {
          this.$store
            .dispatch("userGuide/publishing", {
              userguide: this.userGuide,
              action: action,
            })
            .then((response) => { 
              if(response.data.data.published == 1) {
                this.$toast.success('User guide published successfully!');
              } else {
                this.$toast.success('User guide unpublished successfully!');
              }
             
            });
        },
        deleteuserGuide() {
          this.$store.dispatch("message/update", {
            title: this.userGuide.title,
            body: "Are you sure you want to delete this User Guide?",
            class: "danger",
            confirm: true,
          });
  
          this.$bus.$off("proceed");
          this.$bus.$once("proceed", () => {
            this.delete(this.userGuide);
            this.$store.dispatch("message/close");
          });
        },
        delete(userguide) {
          this.$store.dispatch("userGuide/delete", userguide)
            .then(() => {
              this.$parent.$parent.getUserGuidies(this.pageNumber,'');
              this.$toast.success('User guide deleted successfully!');
            })
            .catch((error) => {
              // send error message
              this.$toast.success(error.response.data.message);
            });
        },
      },
    };
  </script>
  <style scoped>
    table tr td:nth-child(1) {
      width: 35% !important;
      padding-left: 40px;
    }
  
    table tr td:nth-child(2) {
      width: 35% !important;
    }
  
    table tr td:nth-child(3) {
      width: 20% !important;
    }
  
    table tr td:nth-child(4) {
      width: 10% !important;
    }
  </style>